import { Dispatch, SetStateAction } from "react";

export const validateEmail = (
  email: string
): { isValid: boolean; error: string } => {
  console.log("validateEmail called with:", email);

  if (!email) {
    console.log("Email validation failed: Empty email");
    return { isValid: false, error: "Email is required" };
  }

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid = emailPattern.test(email);

  console.log("Email validation result:", { isValid });

  return {
    isValid,
    error: isValid ? "" : "Please enter a valid email address",
  };
};

export const validateIndianPhoneNumber = (
  phoneNumber: string
): { isValid: boolean; error: string } => {
  console.log("validatePhoneNumber called with:", phoneNumber);

  if (!phoneNumber) {
    console.log("Phone validation failed: Empty phone number");
    return { isValid: false, error: "Phone number is required" };
  }

  // Format: +91XXXXXXXXXX (10 digits after country code)
  const indianPhoneRegex = /^\+91[1-9]\d{9}$/;
  const isValid = indianPhoneRegex.test(phoneNumber);

  console.log("Phone validation result:", { isValid });

  return {
    isValid,
    error: isValid
      ? ""
      : "Please enter a valid Indian phone number (+91 followed by 10 digits)",
  };
};

/**
 * Handles phone number input changes
 * Adds +91 prefix and validates number
 */
export const handlePhone = (
  text: string,
  setPhone: (value: string) => void,
  setError: Dispatch<SetStateAction<string>>
): void => {
  // Clean number and add prefix
  let clean = text.replace(/^\+91/, "").replace(/\D/g, "");
  const formatted = `+91${clean}`;

  // Update states
  setPhone(formatted);
  const validation = validateIndianPhoneNumber(formatted);
  setError(validation.error);
};

export const validatePassword = (
  password: string
): { isValid: boolean; error: string } => {
  console.log("validatePassword called with:", password.length, "characters");

  // Early return if empty
  if (!password) {
    console.log("Password validation failed: Empty password");
    return { isValid: false, error: "Password is required" };
  }

  const isValidPassword =
    password.length >= 8 && // min length
    /\d/.test(password) && // has number
    /[A-Z]/.test(password) && // has uppercase
    /[a-z]/.test(password) && // has lowercase
    !/\s/.test(password); // no spaces

  if (!isValidPassword) {
    console.log("Password validation failed: Common requirements not met");
    return {
      isValid: false,
      error: "Password must be 8+ characters with numbers and letters",
    };
  }

  console.log("Password validation passed");
  return { isValid: true, error: "" };
};
